import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Country from '../entities/country'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface CountryState extends ListState<Country>{
    country:Country,
    selectCountry:Country,


}

class CountryMutations extends ListMutations<Country>{

}

class CountryModule extends ListModule<CountryState,any,Country>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Country>(),
        loading:false,
        editCountry:new Country(),
        selectCountry:new Country(),
    
    
    }
    actions={

 
     
        async saveCountry(context:ActionContext<CountryState,any>,payload:any){
         
            context.state.loading=true;
            let reponse=await Ajax.post('/api/services/app/Content/SaveCountry',payload.data);
          
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Country>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getCountries(context:ActionContext<CountryState,any>,payload:any){
            
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Content/GetCountries',payload.data);
          
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Country>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:CountryState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CountryState,pagesize:number){
            state.pageSize=pagesize;
        },
       
    }
}
const countryModule=new CountryModule();
export default countryModule;